<template>
  <div class="addDiscountRule">
    <div class="headler">添加折扣活动</div>

    <div class="basicInfor">
      <div class="title">基础设置</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
        size="mini"
      >

        <el-form-item label="活动名称" prop="name">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleForm.name"
            maxlength="10"
            show-word-limit
            style="width: 300px"
          ></el-input>
          <span class="hint">建议描述具体优惠，如5元优惠卷使用</span>
        </el-form-item>

        <el-form-item label="活动时间" required>
          <el-col :span="4">
            <el-form-item prop="date1">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="ruleForm.date1"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">-</el-col>
          <el-col :span="4">
            <el-form-item prop="date2">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="ruleForm.date2"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item style="margin-top:-12px;">
          <el-checkbox v-model="period">按周期重复</el-checkbox>
          <div class="interval"></div>
          <div class="Custom" v-show="period">
            <el-radio-group v-model="radio">
              <el-radio :label="3" class="marginBtm">
                <span>按天重复</span>
                <div class="interval"></div>
                <el-time-picker
                  v-if="radio==3"
                  is-range
                  v-model="value1"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                ></el-time-picker>
              </el-radio>
              <br />
              <el-radio :label="6" class="marginBtm">
                <span>按周重复</span>
                <div class="interval"></div>
                <template v-if="radio==6">
                  <el-checkbox-group v-model="checkList">
                    <template v-for="(item, index) in weekData">
                      <el-checkbox :label="item" :key="index"></el-checkbox>
                    </template>
                  </el-checkbox-group>
                  <div class="interval"></div>
                  <el-time-picker
                    is-range
                    v-model="value1"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                  ></el-time-picker>
                </template>
              </el-radio>
              <br />
              <el-radio :label="9" class="marginBtm">
                <span>按周重复</span>
                <div class="interval"></div>
                <template v-if="radio == 9">
                  每月
                  <el-input
                    type="text"
                    placeholder="请输入内容"
                    v-model="ruleForm.name"
                    show-word-limit
                    style="width: 100px"
                  ></el-input>日
                  <el-time-picker
                    is-range
                    v-model="value1"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                  ></el-time-picker>
                </template>
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label="活动预告设置" prop="createWay">
          <el-radio-group v-model="ruleForm.createWay">
            <el-radio label="1" class="marginBtm">创建成功后就进行活动预告</el-radio>
            <br />
            <el-radio label="2" class="marginBtm">
              活动开始前
              <el-input
                type="text"
                placeholder="请输入内容"
                v-model="ruleForm.name"
                show-word-limit
                style="width: 100px"
              ></el-input>小时进行活动预告
            </el-radio>
            <br />
            <el-radio label="3" class="marginBtm">不进行活动预告</el-radio>
            <br />
            <div
              class="hint"
              style="margin-top: 0px;font-size: 12px;"
            >活动预告期间，商品详情页价格上方将会展示活动标题开始时间与寒假活动离地，</div>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="活动标题">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleForm.inventory"
            show-word-limit
            style="width: 300px"
          ></el-input>
          <div class="hint" style="font-size: 12px;">2-5个字，活动预告和活动进行期间展示于商品详情页</div>
        </el-form-item>

        <el-form-item label="同步打标签">
          <el-checkbox v-model="checked">给参与活动的用户打标签</el-checkbox>
        </el-form-item>
      </el-form>
    </div>

    <!-- 活动规则 -->
    <div class="basicInfor discounts_rule">
      <div class="title">活动规则</div>
      <el-form
        :model="ruleFormTwo"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        size="mini"
      >
        <el-form-item label="选择商品" prop="nonull">
          <el-button type="text">选择商品</el-button>
        </el-form-item>

        <el-form-item label="促销价抹零设置">
          <el-checkbox v-model="checked">抹零</el-checkbox>
          <br />
          <div class="hint" style="font-size: 12px;">抹零是指付钱时不及整数以外的系小数</div>
        </el-form-item>

        <el-form-item label="限购设置" prop="nonull">
          <el-radio-group v-model="ruleForm.createWay">
            <el-radio label="1" class="marginBtm">不限购</el-radio>
            <br />
            <el-radio label="2" class="marginBtm">
              每人每种商品限购
              <el-input
                type="text"
                placeholder="请输入内容"
                v-model="ruleForm.name"
                show-word-limit
                style="width: 100px"
              ></el-input>件
            </el-radio>
            <br />
            <el-radio label="2" class="marginBtm">
              每人每种商品限购
              <el-input
                type="text"
                placeholder="请输入内容"
                v-model="ruleForm.name"
                show-word-limit
                style="width: 100px"
              ></el-input>件享受折扣
            </el-radio>
            <br />
            <div class="hint" style="margin-top: 0px;font-size: 12px;">开启啊按周期重复后吗，在每个周期内限购设置均渎职</div>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="倒计时设计" prop="nonull">
          <el-radio-group v-model="ruleForm.createWay">
            <el-radio label="1" class="marginBtm">按活动时间倒计时</el-radio>
            <br />
            <el-radio label="2" class="marginBtm">
              自定义倒计时周期
              <el-input
                type="text"
                placeholder="请输入内容"
                v-model="ruleForm.name"
                show-word-limit
                style="width: 100px"
              ></el-input>小时
            </el-radio>
            <br />
            <div class="hint" style="margin-top: 0px;font-size: 12px;">自定义倒计时周期可增强下单压迫感，帮助打造营销氛围</div>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <div class="operation_btn">
      <el-button @click="returnUp">取消</el-button>
      <el-button type="primary">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkList: [],
      weekData: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      value2: "", // 结束时间
      value1: "", // 开始时间
      period: "", // 是否开启周期
      radio: 3,
      checked: false,
      ruleForm: {
        name: "",
        createWay: "",
        inventory: "", //库存
        restrict: "", // 每人限用
        type: "",
        region: "",
        date1: "",
        date2: ""
      },
      ruleFormTwo: {
        type: "",
        subMoney: "", // 减免金额
        useCondition: "", // 使用条件
        applyType: "",
        scene: []
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        nonull: [{ required: true, message: "内容不能为空", trigger: "blur" }], // 公共
        inventory: [
          { required: true, message: "请输入库存信息", trigger: "blur" }
        ],
        restrict: [
          { required: true, message: "请输入限用人数", trigger: "blur" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择开始日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择结束日期",
            trigger: "change"
          }
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        createWay: [
          { required: true, message: "请选择生成方式", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    returnUp() {
      this.$router.replace("discount");
    }
  }
};
</script>

<style lang="scss" scoped>
.addDiscountRule {
  height: 100%;
  padding: 10px 25px 10px 10px;
  border-left: 1px solid #f0f0f0;
  overflow: auto;
  background: #f0f0f0;

  .headler {
    height: 50px;
    line-height: 50px;
    padding-left: 10px;
    font-size: 16px;
    background: #fff;
    margin-bottom: 5px;
  }
  .basicInfor {
    padding: 15px 30px;
    background: #f0f0f0;
    border-radius: 3px;
    margin-bottom: 10px;
    background: #fff;

    .title {
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      font-size: 16px;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 10px;
    }

    .hint {
      font-size: 14px;
      color: #989898;
      margin-left: 10px;
    }

    .btmHint {
      display: flex;
      // justify-content: slex-
    }

    .interval {
      height: 8px;
    }
  }
  .marginBtm {
    margin-bottom: 10px;
  }

  .operation_btn {
    // margin-top: 15px;
    text-align: center;
    background: #fff;
    padding: 10px;
  }
}
</style>
